import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import SeguroService from '@/services/SegurosService'

import { mapInsuranceApiResponse } from './mapInsuranceApiResponse'

export interface InsuranceWidgetInfo {
  widget_tag: {
    text: string
    text_color: string
    background_color: string
    style: string
  }
  widget_title: string
  isChecked: boolean
  checked_text: string
  unchecked_text: string
  amount_value: string
  widget_advantages: {
    widget_advantage_icon: string
    widget_advantage_text: string
  }[]
}

export interface InsuranceWidgetAttributes {
  widget_info: InsuranceWidgetInfo
  bottomsheet?: InsuranceBottomsheet
  experiment?: {
    name: string
    variant: string
  }
  insurance_manual_url: string
  insurance_terms_url: string
}

export interface Insurance extends InsuranceWidgetAttributes {
  eligibility: boolean
}

export interface InsuranceBottomsheet {
  bottomsheet_title: string
  with_insurance_text: string
  without_insurance_text: string
  bottomsheet_advantages: {
    bottomsheet_advantage_icon: string
    bottomsheet_advantage_text: string
  }[]
}

export interface InsuranceApiResponse {
  eligibility: boolean
  section: {
    title: string
    items: Array<{
      attributes: InsuranceWidgetAttributes
    }>
  }
  id?: string
  sort?: string
}

export interface SeguroState {
  loading: boolean
  isSucess: boolean
  error: boolean
  checked: boolean
  data?: Insurance
}

const initialState: SeguroState = {
  loading: false,
  error: false,
  isSucess: false,
  checked: false,
}

export const getWidgetSeguros = createAsyncThunk(
  'widget/seguros',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await SeguroService.getDadosSeguro()
      const mapped = mapInsuranceApiResponse(data)

      if (!mapped) {
        return rejectWithValue('Invalid insurance widget response')
      }

      return mapped
    } catch (e) {
      return rejectWithValue(e)
    }
  },
)

const seguroSlice = createSlice({
  name: 'seguros',
  initialState,
  reducers: {
    setChecked: (state, action: PayloadAction<boolean>) => {
      state.checked = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWidgetSeguros.fulfilled, (state, action) => {
        state.error = false
        state.loading = false
        state.isSucess = true
        state.data = action.payload
      })
      .addCase(getWidgetSeguros.pending, (state) => {
        state.loading = true
        state.error = false
        state.isSucess = false
      })
      .addCase(getWidgetSeguros.rejected, (state) => {
        state.loading = false
        state.error = true
        state.isSucess = false
      })
  },
})

export const { setChecked } = seguroSlice.actions

export default seguroSlice.reducer
